const quoteAction = {
    SELECT_POLICY_FORMS : 'select policy forms',

    MODIFY_BINDING_FORMS : 'modify binding forms',

    REFRESH_QUOTE : 'refresh quote',

    REVERT_TO_SENT : 'revert to sent',

    COPY_QUOTE : 'copy quote',

    COPY_QUOTE_FOR_MULTI_QUOTE_PROPOSAL : 'copy quote for multi quote proposal',

    OPEN_POLICY_ISSUANCE : 'open policy issuance',

    GENERATE_RATING_ATTACHMENTS : 'generate rating attachments',

    VIEW_RATING_ATTACHMENTS : 'view rating attachments',

    ADD_SECTION : 'add section',

    ADD_DOCUMENT : 'add document',

    DELETE_SECTION : 'delete section',

    SEND_BINDER : 'send binder',

    GENERATE_QUOTE : 'generate quote',

    GENERATE_BINDER : 'generate binder'

};

angular.module('gw-um-j2js')
    .constant('quoteAction', quoteAction);